import { render, staticRenderFns } from "./WPGAhome.vue?vue&type=template&id=bd4a9a9e&scoped=true"
import script from "./WPGAhome.vue?vue&type=script&lang=js"
export * from "./WPGAhome.vue?vue&type=script&lang=js"
import style0 from "./WPGAhome.vue?vue&type=style&index=0&id=bd4a9a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4a9a9e",
  null
  
)

export default component.exports